import {
  graphqlApolloClient,
  graphqlApolloClient3
} from "./graphql-apollo-client";

export const DataConnectionService = {
  graphqlApolloClient,
  graphqlApolloClient3
};
